var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLocationAbroad = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 58,
    viewBox: "0 0 47 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4838 0C10.9517 0 0.682617 9.69876 0.682617 21.5354C0.682617 26.1215 2.2296 30.3827 4.84704 33.8865L20.701 56.1452C22.9212 58.8926 24.3969 58.3706 26.2431 56.0002L43.7307 31.5149C44.0841 30.9094 44.3611 30.2656 44.6028 29.6067C45.6818 27.1104 46.282 24.3867 46.282 21.5354C46.2826 9.69876 36.0163 0 23.4838 0ZM23.4815 8.1693C23.6929 8.1693 23.8976 8.24296 24.0549 8.37694L36.2466 18.7381C36.8326 19.2351 36.4609 20.155 35.6738 20.1544H33.4918V33.2514C33.4918 33.6992 33.1082 34.0622 32.6357 34.0622H14.3296C13.8565 34.0622 13.4734 33.6992 13.4734 33.2514V20.155H11.2915C10.5049 20.1556 10.1326 19.2357 10.7186 18.7386L22.9103 8.37752C23.0712 8.24277 23.2731 8.16934 23.4815 8.16988",
    fill: "#595959"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLocationAbroad);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Location_abroad.c650e621f80a5ee8b5b6e08e7cee22bd.svg";